import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import DeleteIcon from "@mui/icons-material/Delete";

import IconButton from "@mui/material/IconButton";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import { useHistory } from "react-router-dom";

import {
  LocalizationProvider,
  DatePicker,
} from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import { useSelector, useDispatch } from "react-redux";
import { setOrderFromDate } from "store/actions/restaurant";
import { useConfirm } from "material-ui-confirm";
import {
  showSuccessSnackbar,
  showErrorSnackbar,
} from "store/actions/snackbarMessage";
import TransactionDeleteDialog from "./TransactionDeleteDialog";

import { NavLink } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import { StoreContext } from "../../context/store.jsx";

const useStyles = makeStyles((theme) => ({
  root: {},
  row: {
    height: "42px",
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(1),
  },
  spacer: {
    flexGrow: 1,
  },
  importButton: {
    marginRight: theme.spacing(1),
  },
  exportButton: {
    marginRight: theme.spacing(1),
  },
  searchInput: {
    marginRight: theme.spacing(1),
  },
}));

const VouchersToolbar = (props) => {
  const { className, ...rest } = props;
  const classes = useStyles();
  const history = useHistory();
  const confirm = useConfirm();
  const dispatch = useDispatch();

  const [buttonLoading, setButtonLoading] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteReason, setDeleteReason] = useState("");

  const { selectIds } = useContext(
    StoreContext
  );

  const setOrderDate = (date) => dispatch(setOrderFromDate(date));
  const selectedDate = useSelector(
    (state) => state.restaurant.orderFromDate
  );
  const selectedTransactionIds = useSelector((state) => state.transaction.ids);
  const showSuccessMessage = (msg) => dispatch(showSuccessSnackbar(msg));
  const showErrorMessage = (msg) => dispatch(showErrorSnackbar(msg));

  const handleDateChange = (date) => {
    console.log("date", date);
    setOrderDate(date);
    history.push("/transactions");
  };

  const deletePromotion = () => {
    //console.log("selectedTransactionIds", selectedTransactionIds);
    if (selectIds && selectIds[0] && selectIds[0].length !== 1) {
      showErrorMessage("Please select a prmotion.");
      return;
    }

    

    confirm({ description: "You are about to delete promotions!" })
      .then(() => {
        setButtonLoading(true);
        props.deleteProxy(selectIds[0], () => {
          setButtonLoading(false);
        })
      })
      .catch(() => {});
  };





  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <div className={classes.row}>
        <span className={classes.spacer} />


        <NavLink to="/newVoucher" className={classes.textLink}>
          <Tooltip title="new voucher">
            <IconButton aria-label="new voucher">
              <AddCircleOutlineIcon />
            </IconButton>
          </Tooltip>
        </NavLink>

 

  
      

  
      </div>

    </div>
  );
};

VouchersToolbar.propTypes = {
  className: PropTypes.string,
};

export default VouchersToolbar;
